import { FormProvider } from 'react-hook-form';
import { useUserBulkDeletion } from './hooks';
import { UserBulkDeletionPresentation } from './presentations';

type Props = {
  /** モーダルを閉じるコールバック */
  onClose: () => void;
  /** 一括削除成功時のコールバック */
  onSuccess: () => void;
};

export const UserBulkDeletion: React.FC<Props> = ({ onClose, onSuccess }) => {
  const {
    state: { methods, registrationType, isConfirmDisabled },
    actions: { handleSubmit },
  } = useUserBulkDeletion({ onSuccess });

  return (
    <FormProvider {...methods}>
      <UserBulkDeletionPresentation
        registrationType={registrationType}
        isConfirmDisabled={isConfirmDisabled}
        onClose={onClose}
        onConfirm={handleSubmit}
      />
    </FormProvider>
  );
};
